import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const BoardAutomationPage = lazy(() => import("./BoardAutomationPage"));
const BoardAutomationFormPage = lazy(() => import("./BoardAutomationFormPage"));
const BoardAutomationLogsPage = lazy(() => import("./BoardAutomationLogsPage"));

export type BoardAutomationPagesNavigationParams = {
  boardAutomation: PageNavParams;
  boardAutomationForm: PageNavParams;
  boardAutomationFormEdit: PageNavParams<{ automationId: string }>;
  boardAutomationLogs: PageNavParams<{ automationId: string }>;
};

export const boardAutomationPagesNavigationConfig: ModulePagesConfig<BoardAutomationPagesNavigationParams> =
  {
    boardAutomation: {
      element: <BoardAutomationPage />,
      path: "board-automation",
      isPrivate: true,
      requiredModules: [SubscriptionPlanModuleId.automation],
    },
    boardAutomationForm: {
      element: <BoardAutomationFormPage />,
      path: "board-automation/form",
      isPrivate: true,
      requiredModules: [SubscriptionPlanModuleId.automation],
    },
    boardAutomationFormEdit: {
      element: <BoardAutomationFormPage />,
      path: "board-automation/:automationId/form",
      isPrivate: true,
      requiredModules: [SubscriptionPlanModuleId.automation],
    },
    boardAutomationLogs: {
      element: <BoardAutomationLogsPage />,
      path: "board-automation/:automationId/logs",
      isPrivate: true,
      requiredModules: [SubscriptionPlanModuleId.automation],
    },
  };
